import './ApplicationAccessStat.scss';

import { AccessStatisticsRow } from './AccessStatisticsRow';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityApplicationStatus } from '@sonar-software/sonar-core';
import { getShortDate } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { Tooltip } from 'antd';
import { useApplicationReference } from '@hooks';
import { WarningOutlined } from '@ant-design/icons';

export interface ApplicationAccessStatProps {
	color: string;
	count: number;
	id: number;
	max: number;
}

export const ApplicationAccessStat : React.FC<ApplicationAccessStatProps> = ({ color, count, id, max }) => {
	const { deletedOn, label, name, status } = useApplicationReference(id);
	const nameDisplay = name ?? id;
	const labelDisplay = label ? ` (${label})` : '';
	const isDeleted = status === DataSecurityApplicationStatus.Deleted;

	const deletedNotice = isDeleted && deletedOn ?
		<Tooltip
			placement='bottom'
			title={ `${COPY_SPECIFIC.HIDDEN} ${getShortDate(deletedOn)}` }>
			<WarningOutlined />
		</Tooltip> : null;

	return (
		<AccessStatisticsRow
			className={ classNames('application-access-stat', { deleted: isDeleted }) }
			clickable={ !isDeleted }
			color={ isDeleted ? undefined : color }
			colorName={ isDeleted ? 'deleted' : undefined }
			count={ count }
			extra={ deletedNotice }
			id={ id }
			key={ id }
			max={ max }
			name={ `${nameDisplay}${labelDisplay}` } />
	);
};
